@if (showTitle) {
<div class="users">
  <h4>{{ 'NGX-MESSAGING.usersSelected' | translate }}</h4>
</div>
} @if (usersSelected?.length) {
<div class="members">
  @for (user of usersSelected; track user.uid) {
  <button (click)="deleteUserSelected(user)" class="members__button members__button-selected">
    {{ user.displayName }}
    <mat-icon svgIcon="close_circle"></mat-icon>
  </button>
  }
</div>
}
